import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/auth-context";
import { GlobalContext } from "../contexts/global-context";

export function RequireAuth({ children }) {
    const { user, setAuthRedirectPath, suppressAuthRedirectRef } = useContext(AuthContext);
    const { setShowAuthModal, setAuthModalType } = useContext(GlobalContext);
    const location = useLocation();

    useEffect(() => {
        if (!user && !suppressAuthRedirectRef.current) {
            setAuthModalType("login");
            setShowAuthModal(true);
            setAuthRedirectPath(location.pathname);
        }
    }, [
        user, 
        setShowAuthModal, 
        setAuthModalType, 
        setAuthRedirectPath, 
        location, 
        suppressAuthRedirectRef
    ]);

    return children;
}